import { AttributeValue } from "../AttributeValue";
import { Feature } from "ol";
import GeoJSON from "ol/format/GeoJSON";

export class ExportUtil {
  /**
   * featuresのジオメトリとattributesの属性を合体させたFeatureCollectionのGeoJSON文字列を返す
   * featuresのpropertiesは無視される
   * また、featuresのidは削除される
   * @param features ジオメトリを持つ地物の配列
   * @param attributes 属性の配列
   * @returns FeatureCollectionのGeoJSON文字列
   */
  public static toJsonFormat(
    features: Feature[],
    attributes: Array<Array<AttributeValue>>
  ): string {
    // 一旦まるごとGeoJSONオブジェクトに変換する
    const geojsonObject = new GeoJSON().writeFeaturesObject(features);

    // FeatureCollection内のpropertiesを頭から順番にattributesへ置き換える
    attributes.forEach((attributeValueArray, index) => {
      // attributeValueの配列からkey-valueを一つずつ取り出してオブジェクトに追加していく
      const properties = attributeValueArray.reduce((acc, attr) => {
        acc[attr.key] = attr.value;
        return acc;
      }, {} as Record<string, any>);

      // feature.propertiesを置き換える
      geojsonObject.features[index].properties = properties;

      // feature.idは削除する
      delete geojsonObject.features[index].id;
    });

    // 見やすくフォーマットするため第三引数でインデント幅を指定
    const geojson = JSON.stringify(geojsonObject, null, 2);
    return geojson;
  }

  /**
   * 複数の地物の属性をCSV文字列にして返す
   * 1行目：カンマ区切りの属性名
   * 2行目以降：カンマ区切りの属性値
   * @param attributes 属性の配列の配列
   * @returns CSVフォーマットの文字列
   */
  public static toCsvFormat(attributes: Array<Array<AttributeValue>>): string {
    // 属性リストの数（地物数）が0、または属性の数が0なら空文字列を返す
    if (attributes.length === 0 || attributes[0].length === 0) return "";

    // ヘッダー行および値は、各項目をダブルクォートで囲む
    const header =
      `"` + attributes[0].map((attr) => attr.key).join(`","`) + `"`;
    const value = attributes
      .map(
        (attributeArray) =>
          `"` + attributeArray.map((attr) => attr.value).join(`","`) + `"`
      )
      .join("\n");

    return header + "\n" + value;
  }
  
  /**
   * ファイル出力時の日付出力
   * @returns ファイル出力時の時間
   */
  public static exportFileDate() {
    const now = new Date();
    const YY = now.getFullYear();
    const MM = String(now.getMonth()+1).padStart(2,"0");
    const DD = String(now.getDate()).padStart(2,"0");
    const hh = String(now.getHours()).padStart(2,"0");
    const mm = String(now.getMinutes()).padStart(2,"0");
    const ss = String(now.getSeconds()).padStart(2,"0");
  
    const formatDate = `${YY}${MM}${DD}_${hh}${mm}${ss}`
    return formatDate
  }
}
